import { useEffect, useState, useRef, MutableRefObject} from 'react'
import Template from './../Template'
import * as SG from '../../style/Styles'
import * as TXT from './../../util/Texts'
import * as RankingService from './../../services/Ranking.service'
import * as UserService from './../../services/User.service'
import * as GroupService from './../../services/Group.service'
import * as U from './../../util/UrlHttp'
import IconFlagSelector from '../../components/IconFlagSelector'

const PerPage:number = 10

export function useVisibility<T>(
    offset = 0,
  ): [boolean, MutableRefObject<T>] {
    const [isVisible, setIsVisible] = useState(false)
    const currentElement = useRef<any>(null)

    const onScroll = () => {
      if (!currentElement.current) {
        setIsVisible(false)
        return
      }
      const top = currentElement.current.getBoundingClientRect().top
      setIsVisible(top + offset >= 0 && top - offset <= window.innerHeight)
    }

    useEffect(() => {
      document.addEventListener('scroll', onScroll, true)
      return () => document.removeEventListener('scroll', onScroll, true)
    })

    return [isVisible, currentElement]
}

export default function Ranking() {

  const [beforeCheckoutSubmitShown, beforeCheckoutSubmitRef] = useVisibility<HTMLDivElement>()
  const tableRef                        = useRef<any>(null)
  const refHeadT                        = useRef<any>(null)
  const [rankingUsers, setRankingUsers] = useState<any>([])
  const [totalUsers, setTotalUsers]     = useState<number>(0)
  const [limitPage, setLimitPage]       = useState<number>(PerPage)
  const [nameF, setNameF]               = useState<string>('')
  const [cs, setCs]                     = useState<string>('')
  const [countryId, setCountryId]       = useState<string>('')
  const [countries, setCountries]       = useState<any[]>([])
  const [plants, setPlants]             = useState<string[]>([])
  const [totalbets, setTotalBets]       = useState<number>(0)
  // DE:PARA sigla do país → icon do language (ex: 'FRA' → 'img/lang/france.png')
  const [langIconMap, setLangIconMap]   = useState<Record<string, string>>({})

  // Grupos que o usuário faz parte
  const [myGroups, setMyGroups]         = useState<any[]>([])
  const [selectedGroup, setSelectedGroup] = useState<string>('')

  const getCs = async () => {

    const result = await UserService.GetCs()
  
    if (result.data && result.data.status) 
      setPlants(result.data.plants)

    // Carrega países do localStorage
    try {
      const stored = localStorage.getItem('app_countries')
      if (stored) setCountries(JSON.parse(stored))
    } catch(e) { console.warn('Erro ao carregar países', e) }

    // Monta DE:PARA sigla → icon do language (mesmo ícone usado no IconFlagSelector)
    // Fallback estático: paths conhecidos no public do frontend
    const SIGLA_KEYWORD: Record<string, string> = {
      FRA: 'france',  ESP: 'spain',   MAR: 'arabe',
      HUN: 'hungary', ITA: 'italy',   GER: 'germany',
      BRA: 'brasil',  POL: 'poland',
    }
    // Paths diretos (public) usados quando o language no DB não tem o arquivo correto
    const SIGLA_FALLBACK: Record<string, string> = {
      FRA: 'img/lang/france.png',   ESP: 'img/lang/spain.png',
      MAR: 'img/lang/morocco.png',  HUN: 'img/lang/hungary.png',
      ITA: 'img/lang/italy.png',    GER: 'img/lang/germany.png',
      BRA: 'img/lang/brasil.png',   POL: 'img/lang/poland.png',
    }
    try {
      const storedLangs = localStorage.getItem('app_languages')
      // Começa com o fallback estático e sobrescreve com o que vier do app_languages
      const map: Record<string, string> = { ...SIGLA_FALLBACK }
      // if (storedLangs) {
      //   const langs: any[] = JSON.parse(storedLangs)
      //   Object.entries(SIGLA_KEYWORD).forEach(([sigla, keyword]) => {
      //     const lang = langs.find((l: any) => l.icon?.toLowerCase().includes(keyword))
      //     if (lang) map[sigla] = lang.icon
      //   })
      // }
      setLangIconMap(map)
    } catch(e) { console.warn('Erro ao montar mapa de ícones', e) }

    return
  }

  const getMyGroups = async () => {
    try {
      const result = await GroupService.GetGroups()
      if (result.data && result.data.status && result.data.groups.length > 0) {
        setMyGroups(result.data.groups)
      }
    } catch (err) {
      console.warn('Erro ao carregar grupos do usuário:', err)
    }
  }

  const getRanking = async (limit:number, currentGroup?: string) => {
    
    const data:any = {
      limit: limit, 
      plantF: cs, 
      name: nameF,
      country_id: countryId,
      group_id: currentGroup !== undefined ? currentGroup : selectedGroup
    }
    const result = await RankingService.GetRanking(data)

    if (result.data && result.data.status) {
      setTotalBets(result.data.totalMatchsEnd)
      setRankingUsers(result.data.rakings)
      setTotalUsers(result.data.totalUser)
    }

    return
  }

  const loadingMore = () => {

    const newLimit = limitPage + PerPage
    
    setLimitPage(newLimit)
    getRanking(newLimit)

    return
  }

  const filter = async () => {
    getRanking(limitPage)
    return
  }

  const onScroll = () => { 
    
    if(refHeadT.current)
      refHeadT.current.scrollLeft = tableRef.current?.scrollLeft

    return
  }

  useEffect(()=>{
    
    if(beforeCheckoutSubmitShown === true) {
      const newLimit = limitPage + PerPage
      setLimitPage(newLimit)
      getRanking(newLimit)
    }

  },[beforeCheckoutSubmitShown])

  // Buscar ranking imediatamente ao trocar de grupo selecionado
  const handleGroupChange = (groupId: string) => {
    setSelectedGroup(groupId)
    getRanking(limitPage, groupId)
  }

  useEffect( ()=> {

    getCs()
    getMyGroups()
    getRanking(limitPage)

  }, [])

  return (
    <Template>

        <SG.CenterItem> 
          <IconFlagSelector />
        </SG.CenterItem>

        <SG.Title className='title' style={{textAlign:'center'}}>{TXT.RANKING}</SG.Title>

        <SG.Flex className='filtersContent'>

          <SG.Input 
            className='inputFilter' 
            type="text" 
            placeholder={TXT.SEACH_USER} 
            onChange={(e)=>{setNameF(e.target.value)}} 
            value={nameF} 
            style={{height:46}}
          />

          <SG.Select 
            className='inputFilter' 
            placeholder={TXT.FILTER_BY_PLANT}
            onChange={(e) => {setCs(e.target.value)}} 
            value={cs}
          >
            <SG.Option value="">{TXT.FILTER_BY_PLANT}</SG.Option>
            { plants.length && plants.map((p:string, i:number) => (
                <SG.Option key={i} >{p}</SG.Option>
            ))}
          </SG.Select >

          {/* Filtro por País */}
          {countries.length > 0 && (
            <SG.Select
              className='inputFilter'
              value={countryId}
              onChange={(e) => setCountryId(e.target.value)}
            >
              <SG.Option value="">{TXT.COUNTRY}</SG.Option>
              {countries.map((c: any) => (
                <SG.Option key={c.id} value={c.id}>
                  {(TXT as any)[`COUNTRY_${c.sigla?.toUpperCase()}`] || c.name}
                </SG.Option>
              ))}
            </SG.Select>
          )}

          {myGroups.length > 0 && (
            <SG.Select 
              className='inputFilter'
              onChange={(e) => handleGroupChange(e.target.value)} 
              value={selectedGroup}
            >
              <SG.Option value="">{TXT.GENERAL_RANKING}</SG.Option>
              {myGroups.map((g: any) => (
                <SG.Option key={g.id} value={g.id}>
                  {`${TXT.GROUP_SINGULAR} ${g.id} - ${g.description}`}
                </SG.Option>
              ))}
            </SG.Select>
          )}

          <SG.Span className='incoFilter' onClick={filter}><i className="fa-solid fa-magnifying-glass"></i></SG.Span>

        </SG.Flex>

        {totalbets > 0 && 
          <SG.Div className='blockTotalBets'>
            {TXT.MATCH_REALIZED} <SG.Span>{totalbets}</SG.Span>
          </SG.Div>
        }

        <SG.BoxWhite className='tableBoxWhite'>
          <SG.Div className="wrap">
            <SG.Div className="headers" ref={refHeadT}>
                <SG.Div className="scroller tracScrol">
                    <SG.Div className="track ts1">
                        <SG.Div className="heading"></SG.Div>
                    </SG.Div>
                    <SG.Div className="track ts2">
                        <SG.Div className="heading"></SG.Div>
                    </SG.Div>
                    <SG.Div className="track ts3 headerth">
                        <SG.Div className="heading">{TXT.PG_ABR}</SG.Div>
                    </SG.Div>
                    <SG.Div className="track ts3 headerth">
                        <SG.Div className="heading ">{TXT.PC_ABR}</SG.Div>
                    </SG.Div>
                    <SG.Div className="track ts3 headerth">
                        <SG.Div className="heading ">{TXT.PV_ABR}</SG.Div>
                    </SG.Div>
                    <SG.Div className="track ts3 headerth">
                        <SG.Div className="heading">{TXT.DG_ABR}</SG.Div>
                    </SG.Div>
                    <SG.Div className="track ts3 headerth">
                        <SG.Div className="heading">{TXT.PP_ABR}</SG.Div>
                    </SG.Div>
                    <SG.Div className="track ts3 headerth">
                        <SG.Div className="heading">{TXT.AC_ABR}</SG.Div>
                    </SG.Div>
                </SG.Div>
            </SG.Div>

            <SG.Div className="tracks tracScrol"  ref={tableRef} onScroll={onScroll}>

            { rankingUsers.length > 0 && rankingUsers.map((rank:any, i:number)=>(
              <SG.Div className="track" key={i}>
                <SG.Div className="entry ts1 posRank">
                  <SG.H3>{rank.position < 10 ? `0${rank.position}` : rank.position}</SG.H3>
                </SG.Div>
                <SG.Div className="entry ts2 nameUserRank">
                  <SG.SubSubTitle className='rankSub'>
                    {rank.country_sigla && langIconMap[rank.country_sigla.toUpperCase()] && (
                      <img
                        src={langIconMap[rank.country_sigla.toUpperCase()]}
                        alt={rank.country_sigla || ''}
                        title={rank.country_name || ''}
                        style={{ width: 22, height: 15, objectFit: 'cover', borderRadius: 3, marginRight: 6, verticalAlign: 'middle', border: '1px solid #ddd' }}
                        onError={(e:any) => { e.currentTarget.style.display = 'none' }}
                      />
                    )}
                    {rank.name}
                  </SG.SubSubTitle>
                  {rank.sector} {rank.sector &&  <br /> } {rank.plant}
                </SG.Div>
                <SG.Div className="entry ts3">
                  <SG.SubSubTitle className='rankSub center'>{rank.PG}</SG.SubSubTitle>
                </SG.Div>
                <SG.Div className="entry ts3 posRank">
                  {rank.PC}
                </SG.Div>
                <SG.Div className="entry ts3 posRank">
                  {rank.PV}
                </SG.Div>
                <SG.Div className="entry ts3 posRank">
                  {rank.DG}
                </SG.Div>
                <SG.Div className="entry ts3 posRank">
                  {rank.PP}
                </SG.Div>
                <SG.Div className="entry ts3 posRank">
                  {rank.AC}
                </SG.Div>
              </SG.Div>
              )) }
            </SG.Div>
          </SG.Div>
        </SG.BoxWhite>

        { totalUsers > rankingUsers.length && 
          <SG.Div ref={beforeCheckoutSubmitRef} className='boxLoading' onClick={loadingMore} title={TXT.LOAD_MORE}>
            <SG.IMG src='/img/loading.gif' alt={TXT.LOADING} />
            <SG.H5>{TXT.LOAD_MORE}</SG.H5>
          </SG.Div>
        }

        <SG.BoxWhite>
          <SG.PADD style={{paddingLeft:40, paddingTop:20}}>
            <SG.SmallTitle className='txtDestak'>{TXT.LEGEND}</SG.SmallTitle>
            <SG.DisableText className='legendTxt'>{TXT.PG}</SG.DisableText>
            <SG.DisableText className='legendTxt'>{TXT.PC}</SG.DisableText>
            <SG.DisableText className='legendTxt'>{TXT.PV}</SG.DisableText>
            <SG.DisableText className='legendTxt'>{TXT.DG}</SG.DisableText>
            <SG.DisableText className='legendTxt'>{TXT.PP}</SG.DisableText>
            <SG.DisableText className='legendTxt'>{TXT.AC}</SG.DisableText>
          </SG.PADD>
        </SG.BoxWhite>

    </Template>
  );

}
  
  